import { Node, mergeAttributes } from '@tiptap/core'
import Suggestion, { SuggestionOptions } from '@tiptap/suggestion'

export const Mention = Node.create({
  name: 'mention',

  addOptions: {
    HTMLAttributes: {},
    suggestion: {
      char: '@',
      command: ({ editor, range, props }) => {
        console.log('command: ', editor, range, props);
        editor
          .chain()
          .focus()
          .insertContentAt(range, [
            {
              type: 'mention',
              attrs: props,
            },
            {
              type: 'text',
              text: ' ',
            },
          ])
          .run()
      },
      allow: ({ editor, range }) => {
        return editor.can().insertContentAt(range, { type: 'mention' })
      },
    },
  },

  group: 'inline',

  inline: true,

  selectable: false,

  atom: true,

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: element => {
          return {
            id: element.getAttribute('data-mention'),
          }
        },
        renderHTML: attributes => {
          if (!attributes.id) {
            return {}
          }

          if (typeof attributes.id !== 'object') {
            return {
              'data-mention': attributes.id,
            };
          }

          if (!attributes.id.id) {
            return {}
          }

          return {
            'data-mention': attributes.id.id,
          }
        },
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-mention]',
      },
    ]
  },

  renderHTML({ node, HTMLAttributes }) {
    // create or edit mention, node.attrs.id is an object
    // need to use parseInt coz in editing the value of id is a string
    let id = parseInt(node.attrs.id.id);

    let fullName = this.options.suggestion.users.find(u => u.id === id).full_name;

    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      `${this.options.suggestion.char}${fullName}`,
    ]
  },

  renderText({ node }) {
    return `${this.options.suggestion.char}${node.attrs.id}`
  },

  addKeyboardShortcuts() {
    return {
      Backspace: () => this.editor.commands.command(({ tr, state }) => {
        let isMention = false
        const { selection } = state
        const { empty, anchor } = selection

        if (!empty) {
          return false
        }

        state.doc.nodesBetween(anchor - 1, anchor, (node, pos) => {
          if (node.type.name === this.name) {
            isMention = true
            tr.insertText(this.options.suggestion.char || '', pos, pos + node.nodeSize)

            return false
          }
        })

        return isMention
      }),
    }
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
      }),
    ]
  },
})
